import { defineComponent, createBlock, openBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementBlock, createCommentVNode, createElementVNode, renderSlot, toDisplayString } from "vue";
import FlowLoader from "./FlowLoader.vue.js";
const _hoisted_1 = {
  key: 0,
  class: "flow-button-decorator"
};
const _hoisted_2 = { class: "flow-button-loader" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowButton",
  props: {
    label: {},
    error: { type: Boolean },
    loaderState: {},
    variant: {},
    title: {},
    icon: { type: Boolean },
    href: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.href ? "a" : "button"), {
        class: normalizeClass(["flow-button", {
          "flow-button-outlined": !_ctx.error && _ctx.variant === "outlined",
          "flow-button-clear": !_ctx.error && _ctx.variant === "clear",
          "flow-button-text": !_ctx.error && _ctx.variant === "text",
          "flow-button--delete": _ctx.error,
          "flow-button-icon-only": _ctx.icon
        }]),
        href: _ctx.href,
        title: _ctx.title || _ctx.label,
        type: _ctx.href ? void 0 : "button"
      }, {
        default: withCtx(() => [
          _ctx.$slots.default ? (openBlock(), createElementBlock("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ])) : createCommentVNode("", true),
          createElementVNode("span", {
            class: normalizeClass({ "sr-only": _ctx.icon })
          }, toDisplayString(_ctx.label), 3),
          createElementVNode("div", _hoisted_2, [
            _ctx.loaderState ? (openBlock(), createBlock(FlowLoader, {
              key: 0,
              loaderState: _ctx.loaderState
            }, null, 8, ["loaderState"])) : createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["class", "href", "title", "type"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowButton.vue2.js.map
